export enum Module {
  Home = "home",
  Tenant = "tenant",
}
